<template>
    <div class="articleSettingBox">
        <ul class="settingUl">
            <li>
                <span>摘要</span>
                <el-switch v-model="data.zhaiyao">
                </el-switch>
            </li>
            <li>
                <span>底部联系</span>
                <el-switch v-model="data.lianxi">
                </el-switch>
            </li>
            <li v-if="data.lianxi">
                <span>联系电话</span>
                <el-input v-model="data.phoneInput" style="width: 200px;" placeholder="请输入11位电话" size="small"></el-input>
            </li>
            <li v-if="data.lianxi">
                <span>按钮背景颜色</span>
                <el-color-picker v-model="data.color1"></el-color-picker>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'articleDeitelSetting',
  props: {
    data: Object
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>
.articleSettingBox {
    padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/article/productDetailSetting.vue